import React from 'react';
import Reveal from './Reveal';

/** Red claw tick + tracked caps label. */
export default function Eyebrow({ children, className = '', delay = 0, tone = 'red', as = 'div' }) {
  return (
    <Reveal rise={false} delay={delay} className={className}>
      {React.createElement(as, { className: `pnp-eyebrow${tone === 'gold' ? ' pnp-eyebrow-gold' : ''}` }, (
        <>
          <span className="pnp-eyebrow-claw" aria-hidden="true"><i /><i /><i /></span>
          <span>{children}</span>
        </>
      ))}
    </Reveal>
  );
}
